import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui';
import { DesignerState } from './DesignerFlow';
interface Props {
  data: DesignerState;
  updateData: (data: Partial<DesignerState>) => void;
  onNext: () => void;
  onBack: () => void;
}
export function Step5Contact({
  data,
  updateData,
  onNext,
  onBack
}: Props) {
  const isValid = data.name && data.email && data.company && data.role && data.planningFor && data.brandedHub;
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12" data-id="element-2563">
      <h1 className="text-3xl font-bold text-brand-navy mb-8" data-id="element-2564">
        Where should we send your full offsite blueprint?
      </h1>

      <div className="space-y-6 mb-8" data-id="element-2565">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-2566">
          <div data-id="element-2567">
            <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2568">
              Name
            </label>
            <input type="text" value={data.name} onChange={e => updateData({
            name: e.target.value
          })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all" data-id="element-2569" />
          </div>
          <div data-id="element-2570">
            <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2571">
              Work email
            </label>
            <input type="email" value={data.email} onChange={e => updateData({
            email: e.target.value
          })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all" data-id="element-2572" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-2573">
          <div data-id="element-2574">
            <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2575">
              Company
            </label>
            <input type="text" value={data.company} onChange={e => updateData({
            company: e.target.value
          })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all" data-id="element-2576" />
          </div>
          <div data-id="element-2577">
            <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2578">
              Role
            </label>
            <input type="text" value={data.role} onChange={e => updateData({
            role: e.target.value
          })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all" data-id="element-2579" />
          </div>
        </div>

        <div data-id="element-2580">
          <label className="block text-sm font-semibold text-slate-700 mb-3" data-id="element-2581">
            Planning for:
          </label>
          <div className="flex flex-wrap gap-2" data-id="element-2582">
            {['My company', 'A client', 'A hotel/resort', 'A DMC', 'Other'].map(opt => <button key={opt} onClick={() => updateData({
            planningFor: opt
          })} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 border ${data.planningFor === opt ? 'bg-brand-navy text-white border-brand-navy shadow-sm' : 'bg-white text-slate-600 border-slate-200 hover:border-brand-teal hover:text-brand-teal'}`} data-id="element-2583">
                  {opt}
                </button>)}
          </div>
        </div>

        <div data-id="element-2584">
          <label className="block text-sm font-semibold text-slate-700 mb-3" data-id="element-2585">
            Would you like a branded event hub for this offsite?
          </label>
          <div className="flex flex-wrap gap-2" data-id="element-2586">
            {['Yes', 'Maybe', 'Not yet'].map(opt => <button key={opt} onClick={() => updateData({
            brandedHub: opt
          })} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 border ${data.brandedHub === opt ? 'bg-brand-navy text-white border-brand-navy shadow-sm' : 'bg-white text-slate-600 border-slate-200 hover:border-brand-teal hover:text-brand-teal'}`} data-id="element-2587">
                {opt}
              </button>)}
          </div>
        </div>
      </div>

      <div className="bg-brand-teal/5 border border-brand-teal/20 rounded-xl p-4 mb-8" data-id="element-2588">
        <p className="text-sm text-brand-navy font-medium" data-id="element-2589">
          Your free blueprint includes agenda ideas, activities, learning
          prompts, intake questions, and recommended success metrics.
        </p>
      </div>

      <div className="mt-10 pt-6 border-t border-slate-100 flex justify-between items-center" data-id="element-2590">
        <Button variant="ghost" onClick={onBack} data-id="element-2591">
          Back
        </Button>
        <Button variant="primary" size="lg" onClick={onNext} disabled={!isValid} data-id="element-2592">
          View My Blueprint
        </Button>
      </div>
    </motion.div>;
}